/**
 * Key for a locally captured scene snapshot, held in `sceneEditor.previews` between the
 * capture and the uploaded derivative coming back from the server.
 *
 * Portrait and landscape snapshots write to different fields on the scene config
 * (`pImageId` / `imageId`), so they are held separately here too.
 *
 * Lives in its own module so selectors can key into the store without importing the
 * slice (whose saga imports selectors in turn).
 */
export const scenePreviewKey = (sceneConfigId: number, portrait?: boolean) =>
  `${sceneConfigId}:${portrait ? 'p' : 'l'}`;
